import { Link } from "gatsby";

function ModalMenu() {
  return (
    <>
      <h3 className="mb-2 text-xs uppercase tracking-widest">
        Information For
      </h3>
      <ul className="mb-6 text-sm">
        <li className="pb-1">
          <a
            href="/apply/first-time"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            First-Time Applicants
          </a>
        </li>
        <li className="pb-1">
          <Link
            to="/college-of-liberal-arts/transfer/"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Transfer Applicants
          </Link>
        </li>
        <li className="pb-1">
          <Link
            to="/apply/international"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            International Applicants
          </Link>
        </li>
        <li className="pb-1">
          <Link
            to="/apply/admitted-students"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Admitted Students
          </Link>
        </li>
        <li className="pb-1">
          <Link
            to="/incoming-students"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Incoming Students
          </Link>
        </li>
        <li className="pb-1">
          <Link
            to="/apply/high-school-counselors"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            High School Counselors
          </Link>
        </li>
      </ul>
      <h3 className="mb-2 text-xs uppercase tracking-widest">
        Information About
      </h3>
      <ul className="mb-6 text-sm">
        <li className="pb-1">
          <a
            href="/college-of-liberal-arts"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Full-Time Undergraduate
          </a>
        </li>
        <li className="pb-1">
          <a
            href="/transfer-to-rollins-college/"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Transferring to Rollins
          </a>
        </li>
        <li className="pb-1">
          <a
            href="https://crummer.rollins.edu"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Graduate Business and Executive Education
          </a>
        </li>
        <li className="pb-1">
          <a
            href="/professional-advancement"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Professional Advancement
          </a>
        </li>
        <li className="pb-1">
          <a
            href="/graduate"
            className="block text-blue-500 hover:underline hover:text-blue-700"
          >
            Graduate Studies
          </a>
        </li>
      </ul>
      <ul className="text-xs grid grid-cols-2 gap-2 text-center items-center tracking-tight font-bold">
        <li className="flex">
          <a
            href="https://apply.rollins.edu/register/request-information"
            className="flex-1 bg-blue-500 p-2 rounded text-white hover:bg-blue-700"
          >
            Request Information
          </a>
        </li>
        <li className="flex">
          <Link
            to="/visit/virtual-tour"
            className="flex-1 bg-blue-500 p-2 rounded text-white hover:bg-blue-700"
          >
            Take a Virtual Tour
          </Link>
        </li>
        <li className="flex">
          <Link
            to="/visit/campus-tours"
            className="flex-1 bg-blue-500 p-2 rounded text-white hover:bg-blue-700"
          >
            Schedule a Tour
          </Link>
        </li>
        <li className="flex">
          <Link
            to="/apply"
            className="flex-1 bg-blue-500 p-2 rounded text-white hover:bg-blue-700"
          >
            Start An Application
          </Link>
        </li>
      </ul>
    </>
  );
}

export default ModalMenu;
